import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ImageWithLinkModule } from 'src/app/angie-shared/components/image-with-link/image-with-link.module';
import { LuStickyFiltersModule } from '../../../../angie-shared/modules/sticky-filters/sticky-filters.module';
import { AuthWrapperModule } from '../../components/auth-wrapper/auth-wrapper.module';
import { AuthConfigService } from '../../service/auth-config.service';
import { SignInRoutingModule } from './sign-in-routing.module';
import { SignInComponent } from './sign-in.component';

@NgModule({
	declarations: [SignInComponent],
	imports: [
		CommonModule,
		AuthWrapperModule,
		SignInRoutingModule,
		ImageWithLinkModule,
		RouterModule,
		TranslateModule,
		LuStickyFiltersModule
	],
	providers: [AuthConfigService]
})
export class SignInModule {}
